import React, { useState } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import * as SettingsActions from '../../../stores/actions/settings';
import { SettingsReducerState } from '../../../stores/reducers/settings';
import LayoutSelector from '../../general-components/layout-selector';
import V_LAYOUTS from '../../../utils/video-layout';
import { VideoState } from '../../../stores/reducers/video';
import { ShotsState } from '../../../stores/reducers/shots';

interface OwnProps {
	updateLayout: (layoutSize: number, newLayout: string) => void;
	previewLayout: string;
	shotFeedsLength: number
}

interface StateProps {
	SettingsReducer: SettingsReducerState;
	VideoReducer: VideoState;
	ShotsReducer: ShotsState;
}

interface DispatchProps {
	setTemplateAccordion: Function;
}

const mapStateToProps = (state: any, ownProps: any) => ({ ...state, ...ownProps });

const mapDispatchToProps = (dispatch: Function) => ({
	setTemplateAccordion: (templateAccordionOpen: boolean) => {
		dispatch(SettingsActions.setTemplateAccordion(templateAccordionOpen));
	},
});

type Props = StateProps & DispatchProps & OwnProps;

function PreviewOnLayouts(props: Props) {
	const {
		previewLayout,
		updateLayout,
		shotFeedsLength,
	} = props;

	const [tab, setTab] = useState(shotFeedsLength);

	return (
		<div className="settings-container layouts-container">
			<div className="presenter-number-label">Number of Presenters</div>
			<div className="presenter-number-selection">
				<div className={classNames('first', 'number', tab === 1 ? 'active' : 'deactive')} onClick={() => setTab(1)}>1</div>
				<div className={classNames('number', tab === 2 ? 'active' : 'deactive')} onClick={() => setTab(2)}>2</div>
				<div className={classNames('number', tab === 3 ? 'active' : 'deactive')} onClick={() => setTab(3)}>3</div>
				<div className={classNames('number', tab === 4 ? 'active' : 'deactive')} onClick={() => setTab(4)}>4</div>
				<div className={classNames('number', tab === 5 ? 'active' : 'deactive')} onClick={() => setTab(5)}>5</div>
				<div className={classNames('number', tab === 6 ? 'active' : 'deactive')} onClick={() => setTab(6)}>6</div>
				<div className={classNames('number', tab === 7 ? 'active' : 'deactive')} onClick={() => setTab(7)}>7</div>
				<div className={classNames('last', 'number', tab === 8 ? 'active' : 'deactive')} onClick={() => setTab(8)}>8</div>
			</div>

			<div className="layout-row-container">
				{tab === 1
					&& <div className="layouts-row">
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.ONE.FULL}
							type={V_LAYOUTS.ONE.FULL}
							number={1}
							displayIcon={false}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.ONE.FULL_PADDING}
							type={V_LAYOUTS.ONE.FULL_PADDING}
							number={1}
							displayIcon={false}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.ONE.HALF}
							type={V_LAYOUTS.ONE.HALF}
							number={1}
							displayIcon={false}
						/>
					</div>
				}

				{tab === 2 && <>
					<div className="layouts-row">
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.TWO.VERTICAL.COVER}
							type={V_LAYOUTS.TWO.VERTICAL.COVER}
							number={2}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.TWO.STACK.RIGHT.CONTAIN}
							type={V_LAYOUTS.TWO.STACK.RIGHT.CONTAIN}
							number={2}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.TWO.HORIZONTAL.CONTAIN}
							type={V_LAYOUTS.TWO.HORIZONTAL.CONTAIN}
							number={2}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.TWO.SPACED}
							type={V_LAYOUTS.TWO.SPACED}
							number={2}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.TWO.MEDIA.SIXTEEN_BY_NINE}
							type={V_LAYOUTS.TWO.MEDIA.SIXTEEN_BY_NINE}
							number={2}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.TWO.MEDIA.FOUR_BY_THREE}
							type={V_LAYOUTS.TWO.MEDIA.FOUR_BY_THREE}
							number={2}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.TWO.PICTURE_IN_PICTURE.BOTTOM_RIGHT}
							type={V_LAYOUTS.TWO.PICTURE_IN_PICTURE.BOTTOM_RIGHT}
							number={2}
							hasPictureInPicture={true}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.TWO.PICTURE_IN_PICTURE.TOP_LEFT}
							type={V_LAYOUTS.TWO.PICTURE_IN_PICTURE.TOP_LEFT}
							number={2}
							hasPictureInPicture={true}
						/>
					</div>
				</>}

				{tab === 3 && <>
					<div className="layouts-row">
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.THREE.VERTICAL.COVER}
							type={V_LAYOUTS.THREE.VERTICAL.COVER}
							number={3}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.THREE.STACK.TOP}
							type={V_LAYOUTS.THREE.STACK.TOP}
							number={3}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.THREE.STACK.LEFT}
							type={V_LAYOUTS.THREE.STACK.LEFT}
							number={3}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.THREE.STACK.RIGHT}
							type={V_LAYOUTS.THREE.STACK.RIGHT}
							number={3}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.THREE.SPACED}
							type={V_LAYOUTS.THREE.SPACED}
							number={3}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.THREE.MEDIA.SIXTEEN_BY_NINE}
							type={V_LAYOUTS.THREE.MEDIA.SIXTEEN_BY_NINE}
							number={3}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.THREE.MEDIA.FOUR_BY_THREE}
							type={V_LAYOUTS.THREE.MEDIA.FOUR_BY_THREE}
							number={3}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.THREE.ASL.DOUBLE_FOUR_BY_THREE}
							type={V_LAYOUTS.THREE.ASL.DOUBLE_FOUR_BY_THREE}
							number={3}
						/>
					</div>
				</>}

				{tab === 4 && <>
					<div className="layouts-row">
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.FOUR.GRID}
							type={V_LAYOUTS.FOUR.GRID}
							number={4}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.FOUR.VERTICAL.COVER}
							type={V_LAYOUTS.FOUR.VERTICAL.COVER}
							number={4}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.FOUR.SPIRAL}
							type={V_LAYOUTS.FOUR.SPIRAL}
							number={4}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.FOUR.MEDIA.SIXTEEN_BY_NINE}
							type={V_LAYOUTS.FOUR.MEDIA.SIXTEEN_BY_NINE}
							number={4}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.FOUR.MEDIA.FOUR_BY_THREE}
							type={V_LAYOUTS.FOUR.MEDIA.FOUR_BY_THREE}
							number={4}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.FOUR.ASL.THREE_BY_FOUR}
							type={V_LAYOUTS.FOUR.ASL.THREE_BY_FOUR}
							number={4}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.FOUR.ASL.SIXTEEN_BY_NINE}
							type={V_LAYOUTS.FOUR.ASL.SIXTEEN_BY_NINE}
							number={4}
						/>
					</div>
				</>}

				{tab === 5 && <>
					<div className="layouts-row">
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.FIVE.STACK.FOUR_BY_THREE}
							type={V_LAYOUTS.FIVE.STACK.FOUR_BY_THREE}
							number={5}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.FIVE.STACK.RIGHT}
							type={V_LAYOUTS.FIVE.STACK.RIGHT}
							number={5}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.FIVE.STACK.TOP_LEFT}
							type={V_LAYOUTS.FIVE.STACK.TOP_LEFT}
							number={5}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.FIVE.STACK.TWO_LEFT}
							type={V_LAYOUTS.FIVE.STACK.TWO_LEFT}
							number={5}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.FIVE.STACK.FOUR_TOP}
							type={V_LAYOUTS.FIVE.STACK.FOUR_TOP}
							number={5}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.FIVE.ASL.NINE_BY_SIXTEEN}
							type={V_LAYOUTS.FIVE.ASL.NINE_BY_SIXTEEN}
							number={5}
						/>
					</div>
				</>}

				{tab === 6 && <>
					<div className="layouts-row">
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.SIX.GRID}
							type={V_LAYOUTS.SIX.GRID}
							number={6}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.SIX.STACK.RIGHT}
							type={V_LAYOUTS.SIX.STACK.RIGHT}
							number={6}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.SIX.STACK.LEFT}
							type={V_LAYOUTS.SIX.STACK.LEFT}
							number={6}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.SIX.STACK.RANDOM}
							type={V_LAYOUTS.SIX.STACK.RANDOM}
							number={6}
						/>
					</div>
				</>}
				{tab === 7
					&& <div className="layouts-row">
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.SEVEN.GRID}
							type={V_LAYOUTS.SEVEN.GRID}
							number={7}
						/>
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.SEVEN.STACK.CENTER}
							type={V_LAYOUTS.SEVEN.STACK.CENTER}
							number={7}
						/>
					</div>
				}
				{tab === 8
					&& <div className="layouts-row">
						<LayoutSelector
							onClick={updateLayout}
							selected={previewLayout === V_LAYOUTS.EIGHT.GRID}
							type={V_LAYOUTS.EIGHT.GRID}
							number={8}
						/>
					</div>
				}
			</div>
		</div>
	);
}

export default connect<StateProps, DispatchProps, OwnProps>(
	mapStateToProps,
	mapDispatchToProps,
)(PreviewOnLayouts);
